import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {PriceListSummaryModel} from "../priceListSummary.model";
import {PartnerSummaryConverter} from "../../../../../partner/common/api/converter/partnerSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class PriceListSummaryConverter extends HttpModelConverter<PriceListSummaryModel> {

    constructor(private partnerConverter: PartnerSummaryConverter) {
        super();
    }

    protected createInstance(): PriceListSummaryModel {
        return new PriceListSummaryModel();
    }

    protected enrichObject(result: PriceListSummaryModel, src: PriceListSummaryModel) {
        result.partner = this.partnerConverter.convert(src.partner);
    }
}
